import { render } from "./ListadoClientes.vue?vue&type=template&id=260171d3&scoped=true"
import script from "./ListadoClientes.vue?vue&type=script&lang=js"
export * from "./ListadoClientes.vue?vue&type=script&lang=js"

import "./ListadoClientes.vue?vue&type=style&index=0&id=260171d3&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260171d3"]])

export default __exports__